// src/lib/resumeCompleteness.js — single source of truth for editor section
// order/labels and per-section completeness (rail dots + outline panel).

export const EDITOR_SECTIONS = [
    { key: 'contact', label: 'Contact' },
    { key: 'experience', label: 'Experience' },
    { key: 'education', label: 'Education' },
    { key: 'certifications', label: 'Certifications' },
    { key: 'awards', label: 'Awards' },
    { key: 'skills', label: 'Skills' },
    { key: 'projects', label: 'Projects' },
    { key: 'summary', label: 'Summary' },
];

const hasText = (v) => typeof v === 'string' && v.trim() !== '';

const LIST_RULES = {
    experience: { source: 'experiences', valid: (e) => hasText(e.role) || hasText(e.company) },
    education: { source: 'educations', valid: (e) => hasText(e.degree) || hasText(e.school) },
    certifications: { source: 'certifications', valid: (e) => hasText(e.name) },
    awards: { source: 'awards', valid: (e) => hasText(e.name) },
    projects: { source: 'projects', valid: (e) => hasText(e.name) },
};

export function deriveCompleteness(data = {}) {
    return EDITOR_SECTIONS.map(({ key, label }) => {
        if (key === 'contact') {
            const c = data.contact || {};
            return { key, label, filled: hasText(c.fullName) || hasText(c.email), count: null };
        }
        if (key === 'summary' || key === 'skills') {
            return { key, label, filled: hasText(data[key]), count: null };
        }
        const rule = LIST_RULES[key];
        const list = Array.isArray(data[rule.source]) ? data[rule.source] : [];
        const count = list.filter(rule.valid).length;
        return { key, label, filled: count > 0, count };
    });
}
